import { ViewModelLineType } from "src/app/state-management/calculation-state";
import { Dimensions } from "src/app/types";
import { CellSide } from "./types/pdf-cell.types";
import { ColumnProps, RowStyle } from "./types/pdf-export.types";


export enum FontWeight {
    THIN = 1,
    LIGHT = 2,
    REGULAR = 0,
    MEDIUM = 3,
    BOLD = 4,
    BLACK = 5,
}

// const getPercentage = (line: ViewModelLine, meta: CalculationMetaApi, propertyName: ValueSetKey) => {
//     // Just hacking to hide percentages from provisional cost lines

//     // So we will not show a percentage in the PDF if
//     // 1. There is no calculation line available (e.g. this is the case for (sub)category headers)
//     // 2. If the calculation line is part of the 'tail' (for lack of proper translation atm)
//     // 3. If the calculation line is a text line
//     if (!line.line || !isCalculationLineApi(line.line) || !!line.line.isTextLine) {
//         return '';
//     }

//     const prop = line.line[propertyName] as ValueSetApi;

//     // Also hide percentage if the net amount is zero or missing. No use to show a percentage if the net amount is zero
//     if(!prop.net){
//         return '';
//     }

//     return line.line[propertyName]?.percent ?? meta?.percentages?.[propertyName] ?? '';
// }

// export const TRANSLATE_CALCULATION_PATH: { [path: string]: (line: ViewModelLine, meta?: CalculationMetaApi) => string | number } =
// {
//     'description': (line: ViewModelLine) => line.description ?? line.line?.description,
//     'code': (line: ViewModelLine) => {
//         if (!line.line) {
//             return line.code;
//         } else if(isCalculationLineApi(line.line) && line.line.unit?.startsWith('spt')){
//             return 'stelpost';
//         }

//         return '';
//     },
//     'quantity': (line: ViewModelLine) => (line.line as any)?.quantity ?? '',
//     'unit': (line: ViewModelLine) => (line.line as any)?.unit ?? '',
//     'hoursNorm': (line: ViewModelLine) => line.aggregation?.hours.norm ?? '',
//     'hoursTotal': (line: ViewModelLine) => line.aggregation?.hours.hours ?? 0,
//     'hoursNet': (line: ViewModelLine) => line.aggregation?.hours.net ?? 0,
//     'hoursGross': (line: ViewModelLine) => line.aggregation?.hours.gross ?? 0,
//     'hoursUnit': (line: ViewModelLine) => line.aggregation?.hours.unitPrice ?? 0,
//     'hoursPercentage': (line: ViewModelLine, meta?: CalculationMetaApi) => getPercentage(line, meta, 'hours'),
//     'materialNorm': (line: ViewModelLine) => line.aggregation?.material.norm ?? '',
//     'materialNet': (line: ViewModelLine) => line.aggregation?.material.net ?? 0,
//     'materialGross': (line: ViewModelLine) => line.aggregation?.material.gross ?? 0,
//     'materialUnit': (line: ViewModelLine) => line.aggregation?.material.unitPrice ?? 0,
//     'materialPercentage': (line: ViewModelLine, meta?: CalculationMetaApi) => getPercentage(line, meta, 'material'),
//     'equipmentNorm': (line: ViewModelLine) => line.aggregation?.equipment.norm ?? '',
//     'equipmentNet': (line: ViewModelLine) => line.aggregation?.equipment.net ?? 0,
//     'equipmentGross': (line: ViewModelLine) => line.aggregation?.equipment.gross ?? 0,
//     'equipmentUnit': (line: ViewModelLine) => line.aggregation?.equipment.unitPrice ?? 0,
//     'equipmentPercentage': (line: ViewModelLine, meta?: CalculationMetaApi) => getPercentage(line, meta, 'equipment'),
//     'subcontractingNorm': (line: ViewModelLine) => line.aggregation?.subcontracting.norm ?? '',
//     'subcontractingUnit': (line: ViewModelLine) => line.aggregation?.subcontracting.unitPrice ?? 0,
//     'subcontractingGross': (line: ViewModelLine) => line.aggregation?.subcontracting.gross ?? 0,
//     'subcontractingNet': (line: ViewModelLine) => line.aggregation?.subcontracting.net ?? 0,
//     'subcontractingPercentage': (line: ViewModelLine, meta?: CalculationMetaApi) => getPercentage(line, meta, 'subcontracting'),
//     'unitPrice': (line: ViewModelLine) => {
//         switch (line.type) {
//             case ViewModelLineType.TAIL_PERCENTAGE:
//                 return `${formatterPercentage.format(Number(((line.line as CalculationTailApi)?.percent ?? 0).toFixed(5)) * 100)}%`;
//             default: return line.aggregation?.all.unitPrice ?? 0
//         }
//     },
//     'netTotal': (line: ViewModelLine) => line.aggregation?.all.net ?? 0,
//     'grossTotal': (line: ViewModelLine) => line.aggregation?.all.gross ?? 0,
// }

export enum PAPER_SIZE { A3 = 'a3', A4 = 'a4' };

export const PAPER_DIMENSIONS: { [key in PAPER_SIZE]: Dimensions } = {
    [PAPER_SIZE.A3]: { width: 841.89, height: 1190.55 },
    [PAPER_SIZE.A4]: { width: 595.28, height: 841.89 }
}

export const ROW_STYLES: { [key in ViewModelLineType]: RowStyle } = {
    calculation: {
        textStyle: {
            fontSize: 8,
            weight: FontWeight.LIGHT
        }, margin: { left: 0, top: 4, right: 2, bottom: 1 }, lineSpacing: 1.2,
        columnFormatOverrides: {
            'CODE': { textStyle: { fontSize: 6 }, margin: { top: 4 } }
        }
    },
    text: {
        textStyle: {
            fontSize: 8,
            weight: FontWeight.LIGHT,
            boldWeight: FontWeight.MEDIUM,
            // isItalic: true,
            color: 0x1b1b1b
        }, margin: { left: 0, top: 3, right: 2, bottom: 1 }, lineSpacing: 1.2
    },
    category: {
        textStyle: {
            fontSize: 10,
            weight: FontWeight.MEDIUM,
            color: 0xffffff
        },
        backgroundColor: 0x1b1b1b,
        margin: {
            left: 0,
            top: 3,
            bottom: 1
        },
        columnFormatOverrides: {
            'HOURS_NORM': { textStyle: { fontSize: 8 }, margin: { top: 5 } },
            'MATERIAL_NORM': { textStyle: { fontSize: 8 }, margin: { top: 5 } },
            'EQUIPMENT_NORM': { textStyle: { fontSize: 8 }, margin: { top: 5 } },
            'SUBCONTRACTING_NORM': { textStyle: { fontSize: 8 }, margin: { top: 5 } },

            'HOURS_NET': { textStyle: { fontSize: 8 }, margin: { top: 5 } },
            'MATERIAL_NET': { textStyle: { fontSize: 8 }, margin: { top: 5 } },
            'EQUIPMENT_NET': { textStyle: { fontSize: 8 }, margin: { top: 5 } },
            'SUBCONTRACTING_NET': { textStyle: { fontSize: 8 }, margin: { top: 5 } },

            'HOURS_GROSS': { textStyle: { fontSize: 8 }, margin: { top: 5 } },
            'MATERIAL_GROSS': { textStyle: { fontSize: 8 }, margin: { top: 5 } },
            'EQUIPMENT_GROSS': { textStyle: { fontSize: 8 }, margin: { top: 5 } },
            'SUBCONTRACTING_GROSS': { textStyle: { fontSize: 8 }, margin: { top: 5 } },

            'GROSS_TOTAL': { textStyle: { fontSize: 8 }, margin: { top: 5 } },
            'UNIT_PRICE': { textStyle: { fontSize: 8 } },
            'NR_OF_HOURS': { textStyle: { fontSize: 8 }, margin: { top: 5 } },
        }
    },
    subcategory: {
        textStyle: {
            fontSize: 9,
            weight: FontWeight.LIGHT,
            color: 0x000000
        },
        backgroundColor: 0xe1e1e1,
        border: {
            color: 0xffffff,
            thickness: 2,
            sides: CellSide.horizontal
        },
        margin: { left: 0, top: 3, bottom: 3 },
        columnFormatOverrides: {
            'HOURS_NORM': { textStyle: { fontSize: 8 }, margin: { top: 2 } },
            'MATERIAL_NORM': { textStyle: { fontSize: 8 }, margin: { top: 2 } },
            'EQUIPMENT_NORM': { textStyle: { fontSize: 8 }, margin: { top: 2 } },
            'SUBCONTRACTING_NORM': { textStyle: { fontSize: 8 }, margin: { top: 2 } },

            'HOURS_NET': { textStyle: { fontSize: 8 }, margin: { top: 2 } },
            'MATERIAL_NET': { textStyle: { fontSize: 8 }, margin: { top: 2 } },
            'EQUIPMENT_NET': { textStyle: { fontSize: 8 }, margin: { top: 2 } },
            'SUBCONTRACTING_NET': { textStyle: { fontSize: 8 }, margin: { top: 2 } },

            'HOURS_GROSS': { textStyle: { fontSize: 8 }, margin: { top: 2 } },
            'MATERIAL_GROSS': { textStyle: { fontSize: 8 }, margin: { top: 2 } },
            'EQUIPMENT_GROSS': { textStyle: { fontSize: 8 }, margin: { top: 2 } },
            'SUBCONTRACTING_GROSS': { textStyle: { fontSize: 8 }, margin: { top: 2 } },

            'GROSS_TOTAL': { textStyle: { fontSize: 8 }, margin: { top: 4 } },
            'UNIT_PRICE': { textStyle: { fontSize: 8 } },
            'NR_OF_HOURS': { textStyle: { fontSize: 8 }, margin: { top: 2 } },
        }
    },
    subtotal: {
        textStyle: {
            fontSize: 8,
            weight: FontWeight.REGULAR
        },
        margin: {
            left: 5, top: 4, right: 2, bottom: 5
        },
        lineSpacing: 1,
        border: {
            color: 0xc0c0c0,
            sides: CellSide.top,
            thickness: 0.5
        },
        columnFormatOverrides: {
            'DESCRIPTION': { dataType: 'fixed', fixedValue: { nl: 'Subtotaal', en: 'Subtotal' }, horizontalTextAlignment: 'right' },
            'CODE': {
                border: {
                    sides: CellSide.none
                }
            }
        }
    },
    tailAmount: {
        textStyle: {
            fontSize: 8,
            weight: FontWeight.LIGHT
        }, margin: { left: 0, top: 4, right: 2, bottom: 1 }, lineSpacing: 1.1
    },
    tailPercentage: {
        textStyle: {
            fontSize: 8,
            weight: FontWeight.LIGHT
        }, margin: { left: 0, top: 4, right: 2, bottom: 1 }, lineSpacing: 1.1,
        columnFormatOverrides: {
            UNIT_PRICE: {
                colType: "text"
            }
        }
    },
    tailPrelimanary: {
        textStyle: {
            fontSize: 8,
            weight: FontWeight.LIGHT
        }, margin: { left: 0, top: 4, right: 2, bottom: 1 }, lineSpacing: 1.1
    },
    tailSubtotal: {
        textStyle: {
            fontSize: 8,
            weight: FontWeight.REGULAR
        }, margin: { left: 0, top: 4, right: 2, bottom: 1 }, lineSpacing: 1.1,
        columnFormatOverrides: {
            'DESCRIPTION': {
                horizontalTextAlignment: 'right'
            },
            GROSS_TOTAL: {
                border: {
                    color: 0xc000000,
                    sides: CellSide.top,
                    thickness: 1.0
                }
            }
        }
    },
    tailText: {
        textStyle: {
            fontSize: 8,
            weight: FontWeight.LIGHT
        }, margin: { left: 0, top: 4, right: 2, bottom: 1 }, lineSpacing: 1.1
    },
    total: {
        textStyle: {
            fontSize: 8,
            weight: FontWeight.REGULAR
        },
        margin: {
            left: 5, top: 5, right: 2, bottom: 4
        },
        lineSpacing: 1,
        columnFormatOverrides: {
            'DESCRIPTION': {
                horizontalTextAlignment: 'right'
            },
            GROSS_TOTAL: {
                border: {
                    color: 0xc000000,
                    sides: CellSide.top,
                    thickness: 1.0
                }
            }
        }
    },
    readOnly: {
        textStyle: {
            fontSize: 8,
            weight: FontWeight.LIGHT
        }, margin: { left: 0, top: 4, right: 2, bottom: 1 }, lineSpacing: 1.1
    },
};

export const EXTERNAL_QUOTE_COLUMNS: ColumnProps[] = [
    { columnId: 'CODE', relativeWidth: 1.4, columnHeaderLabel: { nl: 'Code', en: 'Code' }, horizontalTextAlignment: 'center' },
    { columnId: 'DESCRIPTION', relativeWidth: 15, columnHeaderLabel: { nl: 'Omschrijving', en: 'Description' }, horizontalTextAlignment: 'left' },
    { columnId: 'QUANTITY', relativeWidth: 2, columnHeaderLabel: { nl: 'Aantal', en: 'Quantity' }, colType: 'number', margin: { right: 2 }, horizontalTextAlignment: 'right' },
    { columnId: 'UNIT', relativeWidth: 1, columnHeaderLabel: { nl: 'Ehd', en: 'unit' }, margin: { left: 0 }, horizontalTextAlignment: 'left' },
    { columnId: 'UNIT_PRICE', relativeWidth: 3, columnHeaderLabel: { nl: 'Ehd prijs', en: 'Unit price' }, colType: 'currency', horizontalTextAlignment: 'right' },
    { columnId: 'GROSS_TOTAL', relativeWidth: 3, columnHeaderLabel: { nl: 'Bruto', en: 'Total' }, colType: 'currency', horizontalTextAlignment: 'right' },
];

export const INTERNAL_OPEN_QUOTE_COLUMNS: ColumnProps[] = [
    { columnId: 'CODE', relativeWidth: 2, columnHeaderLabel: { nl: 'Code', en: 'Code' }, horizontalTextAlignment: 'center' },
    { columnId: 'DESCRIPTION', relativeWidth: 11, columnHeaderLabel: { nl: 'Omschrijving', en: 'Description' }, horizontalTextAlignment: 'left' },
    { columnId: 'QUANTITY', relativeWidth: 2, columnHeaderLabel: { nl: 'Aantal', en: 'Quantity' }, colType: 'number', margin: { right: 2 }, horizontalTextAlignment: 'right' },
    { columnId: 'UNIT', relativeWidth: 1, columnHeaderLabel: { nl: 'Ehd', en: 'unit' }, margin: { left: 0 }, horizontalTextAlignment: 'left' },
    { columnId: 'HOURS_NORM', relativeWidth: 3, columnHeaderLabel: { nl: 'Norm', en: 'Norm' }, colType: 'number', horizontalTextAlignment: 'right' },
    { columnId: 'HOURS_TOTAL', relativeWidth: 3, columnHeaderLabel: { nl: 'Uren', en: 'Hours' }, colType: 'number', horizontalTextAlignment: 'right' },
    { columnId: 'HOURS_PERCENTAGE', relativeWidth: 1.2, columnHeaderLabel: { nl: 'A%', en: 'A%' }, colType: 'percentage', horizontalTextAlignment: 'right' },
    { columnId: 'HOURS_GROSS', relativeWidth: 4, columnHeaderLabel: { nl: 'Arbeid', en: 'Labour' }, colType: 'currency', horizontalTextAlignment: 'right' },
    { columnId: 'MATERIAL_NORM', relativeWidth: 3, columnHeaderLabel: { nl: 'MA', en: 'MA' }, colType: 'currency', horizontalTextAlignment: 'right' },
    { columnId: 'MATERIAL_NET', relativeWidth: 3, columnHeaderLabel: { nl: 'Netto', en: 'Net' }, colType: 'currency', horizontalTextAlignment: 'right' },
    { columnId: 'MATERIAL_PERCENTAGE', relativeWidth: 1.2, columnHeaderLabel: { nl: 'MA%', en: 'MA%' } , colType: 'percentage', horizontalTextAlignment: 'right'},
    { columnId: 'MATERIAL_GROSS', relativeWidth: 4, columnHeaderLabel: { nl: 'Materiaal', en: 'Material' }, colType: 'currency', horizontalTextAlignment: 'right' },
    { columnId: 'EQUIPMENT_NORM', relativeWidth: 3, columnHeaderLabel: { nl: 'ME', en: 'ME' }, colType: 'currency', horizontalTextAlignment: 'right' },
    { columnId: 'EQUIPMENT_NET', relativeWidth: 3, columnHeaderLabel: { nl: 'Netto', en: 'Net' }, colType: 'currency', horizontalTextAlignment: 'right' },
    { columnId: 'EQUIPMENT_PERCENTAGE', relativeWidth: 1.2, columnHeaderLabel: { nl: 'ME%', en: 'ME%' }, colType: 'percentage', horizontalTextAlignment: 'right' },
    { columnId: 'EQUIPMENT_GROSS', relativeWidth: 4, columnHeaderLabel: { nl: 'Materieel', en: 'Equipment' }, colType: 'currency', horizontalTextAlignment: 'right' },
    { columnId: 'SUBCONTRACTING_NORM', relativeWidth: 3, columnHeaderLabel: { nl: 'OA', en: 'OA' } , colType: 'currency', horizontalTextAlignment: 'right'},
    { columnId: 'SUBCONTRACTING_NET', relativeWidth: 3, columnHeaderLabel: { nl: 'Netto', en: 'Net' }, colType: 'currency', horizontalTextAlignment: 'right' },
    { columnId: 'SUBCONTRACTING_PERCENTAGE', relativeWidth: 1.2, columnHeaderLabel: { nl: 'OA%', en: 'OA%' }, colType: 'percentage', horizontalTextAlignment: 'right' },
    { columnId: 'SUBCONTRACTING_GROSS', relativeWidth: 4, columnHeaderLabel: { nl: 'OA', en: 'Subcontracting' }, colType: 'currency', horizontalTextAlignment: 'right' },
    { columnId: 'UNIT_PRICE', relativeWidth: 4, columnHeaderLabel: { nl: 'Ehd prijs', en: 'Unit price' }, colType: 'currency', horizontalTextAlignment: 'right' },
    { columnId: 'GROSS_TOTAL', relativeWidth: 4, columnHeaderLabel: { nl: 'Totaal', en: 'Total' }, colType: 'currency', horizontalTextAlignment: 'right' },
];

export const DESCRIPTION_EXPORT_COLUMNS: ColumnProps[] = [
    { columnId: 'CODE', relativeWidth: 2, columnHeaderLabel: { nl: 'Code', en: 'Code' }, horizontalTextAlignment: 'center' },
    { columnId: 'DESCRIPTION', relativeWidth: 11, columnHeaderLabel: { nl: 'Omschrijving', en: 'Description' }, horizontalTextAlignment: 'left' },
];

export const EXTERNAL_OPEN_QUOTE_COLUMNS: ColumnProps[] = [
    { columnId: 'CODE', relativeWidth: 1.4, columnHeaderLabel: { nl: 'Code', en: 'Code' }, horizontalTextAlignment: 'center' },
    { columnId: 'DESCRIPTION', relativeWidth: 15, columnHeaderLabel: { nl: 'Omschrijving', en: 'Description' }, horizontalTextAlignment: 'left' },
    { columnId: 'QUANTITY', relativeWidth: 2, columnHeaderLabel: { nl: 'Aantal', en: 'Quantity' }, colType: 'number', margin: { right: 2 }, horizontalTextAlignment: 'right' },
    { columnId: 'UNIT', relativeWidth: 1, columnHeaderLabel: { nl: 'Ehd', en: 'unit' }, margin: { left: 0 }, horizontalTextAlignment: 'left' },
    { columnId: 'HOURS_NORM', relativeWidth: 3, columnHeaderLabel: { nl: 'Norm', en: 'Norm' }, colType: 'number', horizontalTextAlignment: 'right' },
    { columnId: 'HOURS_TOTAL', relativeWidth: 3, columnHeaderLabel: { nl: 'Uren', en: 'Hours' }, colType: 'number', horizontalTextAlignment: 'right' },
    { columnId: 'HOURS_GROSS', relativeWidth: 4, columnHeaderLabel: { nl: 'Arbeid', en: 'Labour' }, colType: 'currency', horizontalTextAlignment: 'right' },
    { columnId: 'MATERIAL_UNIT', relativeWidth: 3, columnHeaderLabel: { nl: 'MA/eenh', en: 'MA/unit' }, colType: 'currency', horizontalTextAlignment: 'right' },
    { columnId: 'MATERIAL_GROSS', relativeWidth: 4, columnHeaderLabel: { nl: 'Materiaal', en: 'Material' }, colType: 'currency', horizontalTextAlignment: 'right' },
    { columnId: 'EQUIPMENT_UNIT', relativeWidth: 3, columnHeaderLabel: { nl: 'ME/eenh', en: 'EQ/unit' }, colType: 'currency', horizontalTextAlignment: 'right' },
    { columnId: 'EQUIPMENT_GROSS', relativeWidth: 4, columnHeaderLabel: { nl: 'Materieel', en: 'Equipment' }, colType: 'currency', horizontalTextAlignment: 'right' },
    { columnId: 'SUBCONTRACTING_UNIT', relativeWidth: 3, columnHeaderLabel: { nl: 'OA/eenh', en: 'Subc/unit' }, colType: 'currency', horizontalTextAlignment: 'right' },
    { columnId: 'SUBCONTRACTING_GROSS', relativeWidth: 4, columnHeaderLabel: { nl: 'OA', en: 'Subcontr' }, colType: 'currency', horizontalTextAlignment: 'right' },
    { columnId: 'UNIT_PRICE', relativeWidth: 4, columnHeaderLabel: { nl: 'Ehd prijs', en: 'Unit price' }, colType: 'currency', horizontalTextAlignment: 'right' },
    { columnId: 'GROSS_TOTAL', relativeWidth: 4, columnHeaderLabel: { nl: 'Totaal', en: 'Total' }, colType: 'currency', horizontalTextAlignment: 'right' },
];

export const QUANTITIES_COLUMNS: ColumnProps[] = [
    { columnId: 'CODE', relativeWidth: 1.6, columnHeaderLabel: { nl: 'Code', en: 'Code' }, horizontalTextAlignment: 'center' },
    { columnId: 'DESCRIPTION', relativeWidth: 11, columnHeaderLabel: { nl: 'Omschrijving', en: 'Description' }, horizontalTextAlignment: 'left' },
    { columnId: 'QUANTITY', relativeWidth: 2, columnHeaderLabel: { nl: 'Aantal', en: 'Quantity' }, colType: 'number', margin: { right: 2 }, horizontalTextAlignment: 'right' },
    { columnId: 'UNIT', relativeWidth: 1, columnHeaderLabel: { nl: 'Ehd', en: 'unit' }, margin: { left: 0 }, horizontalTextAlignment: 'left' },
];

export const HOURS: ColumnProps[] = [
    { columnId: 'CODE', relativeWidth: 2, columnHeaderLabel: { nl: 'Code', en: 'Code' }, horizontalTextAlignment: 'center' },
    { columnId: 'DESCRIPTION', relativeWidth: 11, columnHeaderLabel: { nl: 'Omschrijving', en: 'Description' }, horizontalTextAlignment: 'left' },
    // { columnId: 'QUANTITY', relativeWidth: 2, variablePath: 'quantity', columnHeaderLabel: { nl: 'Aantal', en: 'Quantity' }, colType: 'number', margin: { right: 2 }, horizontalTextAlignment: 'right' },
    // { columnId: 'UNIT', relativeWidth: 1, variablePath: 'unit', columnHeaderLabel: { nl: 'Ehd', en: 'unit' }, margin: { left: 0 }, horizontalTextAlignment: 'left' },
    // { columnId: 'HOURS_NORM', relativeWidth: 3, variablePath: 'hoursNorm', columnHeaderLabel: { nl: 'Norm', en: 'Norm' }, colType: 'number', horizontalTextAlignment: 'right' },
    { columnId: 'HOURS_TOTAL', relativeWidth: 3, columnHeaderLabel: { nl: 'Uren', en: 'Hours' }, colType: 'number', horizontalTextAlignment: 'right' },
    // { columnId: 'HOURS_PERCENTAGE', relativeWidth: 1.2, variablePath: 'hoursPercentage', columnHeaderLabel: { nl: 'A%', en: 'A%' }, colType: 'percentage', horizontalTextAlignment: 'right' },
    // { columnId: 'HOURS_GROSS', relativeWidth: 4, variablePath: 'hoursGross', columnHeaderLabel: { nl: 'Arbeid', en: 'Labour' }, colType: 'currency', horizontalTextAlignment: 'right' },
];